import { render, staticRenderFns } from "./quyuchanpin.vue?vue&type=template&id=6eb6ebaa"
import script from "./quyuchanpin.vue?vue&type=script&lang=js"
export * from "./quyuchanpin.vue?vue&type=script&lang=js"
import style0 from "./quyuchanpin.vue?vue&type=style&index=0&id=6eb6ebaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports